export default "__VITE_ASSET__BY_eKS79__"